import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';

export const WhatsAppButton = () => {
  const { settings } = useSettings();
  const phone = (settings.contact?.whatsapp || '+905522829983').replace(/[^0-9+]/g, '').replace('+', '');

  return (
    <a
      href={`https://wa.me/${phone}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contact via WhatsApp"
      className="fixed bottom-6 right-6 z-40 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-xl transition-all duration-300 hover:scale-110"
      data-testid="whatsapp-float-btn"
    >
      <MessageCircle size={28} />
    </a>
  );
};
